import { useEffect, useState } from "react";
import { Building2, Users, Wallet, Receipt } from "lucide-react";
import { StatCard } from "@/components/common";
import { adminApi, brl, STATUS_LABELS } from "@/lib/api";

export function AdminOverview({ tick }) {
  const [s, setS] = useState(null);
  useEffect(() => { adminApi.get("/stats").then((r) => setS(r.data)).catch(() => {}); }, [tick]);
  if (!s) return null;
  return (
    <div className="space-y-3">
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        <StatCard label="Clientes" value={s.tenants} icon={Building2} testId="admin-stat-tenants" />
        <StatCard label="Usuários" value={s.users} icon={Users} tone="teal" testId="admin-stat-users" />
        <StatCard label="Receita de assinaturas" value={brl(s.subscription_revenue)} icon={Wallet} tone="success" hint={`${s.payments} pagamento(s)`} testId="admin-stat-revenue" />
        <StatCard label="Vendas dos clientes" value={brl(s.sales_volume)} icon={Receipt} tone="warning" hint={`${s.sales_count} venda(s)`} testId="admin-stat-sales" />
      </div>
      <div className="flex flex-wrap gap-2 text-xs" data-testid="admin-status-breakdown">
        {Object.entries(s.by_status).map(([k, v]) => <span key={k} className="rounded-full border px-3 py-1">{STATUS_LABELS[k] || k}: <b>{v}</b></span>)}
      </div>
    </div>
  );
}
